import { useEffect, useState } from 'react';

export function useFlexWrapDetection(containerRef) {
    const [wrappedIndices, setWrappedIndices] = useState([]);

    useEffect(() => {
        if (!containerRef?.current) {
            return;
        }

        const checkWrap = () => {
            const items = containerRef.current?.children;
            if (!items?.length) return;
            //
            const firstTop = items[0].offsetTop;
            const newWrapped = [];
            //
            Array.from(items).forEach((item, index) => {
                if (item.offsetTop > firstTop) {
                    newWrapped.push(index);
                }
            });

            setWrappedIndices(newWrapped);//TODO this makes the containerRef rerender
        };

        checkWrap();

        const resizeObserver = new ResizeObserver(() => checkWrap());
        resizeObserver.observe(containerRef.current);

        window.addEventListener('resize', checkWrap);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', checkWrap);
        };
    }, [containerRef]);

    return { wrappedIndices };
}
